export default "__VITE_ASSET__8a83654e__"